// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://arbiscan.io/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://arbiscan.io/address/0xD3cF979e676265e4f6379749DECe4708B9A22476
export const PROXY_ADMIN = '0xD3cF979e676265e4f6379749DECe4708B9A22476';

// https://arbiscan.io/address/0x3b56998Ec06477704622ca8e2eA1b4db134cec32
export const CREATE_3_FACTORY = '0x3b56998Ec06477704622ca8e2eA1b4db134cec32';

// https://arbiscan.io/address/0xaa944aD95e51CB83C1f35FAEEDfC7d2c31B0BB4d
export const AAVE_CL_ROBOT_OPERATOR = '0xaa944aD95e51CB83C1f35FAEEDfC7d2c31B0BB4d';

// https://arbiscan.io/address/0xCb45E82419baeBCC9bA8b1e5c7858e48A3B26Ea6
export const PROTOCOL_GUARDIAN = '0xCb45E82419baeBCC9bA8b1e5c7858e48A3B26Ea6';

// https://arbiscan.io/address/0xB1552C5e96B312d0Bf8b554186F846C40614a540
export const wstETH_stETH_AGGREGATOR = '0xB1552C5e96B312d0Bf8b554186F846C40614a540';

// https://arbiscan.io/address/0xF3272CAfe65b190e76caAF483db13424a3e23dD2
export const rETH_ETH_AGGREGATOR = '0xF3272CAfe65b190e76caAF483db13424a3e23dD2';

// https://arbiscan.io/address/0x7d9103572bE58FfE99dc390E8246f02dcAe6f611
export const LEGACY_BRIDGE_EXECUTOR = '0x7d9103572bE58FfE99dc390E8246f02dcAe6f611';

// https://arbiscan.io/address/0x0335ffa9af5CE05590d6C9A75B645470e07744a9
export const AAVE_ARB_ETH_BRIDGE = '0x0335ffa9af5CE05590d6C9A75B645470e07744a9';

// https://arbiscan.io/address/0x22740deBa78d5a0c24C58C740e3715ec29de1bFa
export const AFC_SAFE = '0x22740deBa78d5a0c24C58C740e3715ec29de1bFa';

// https://arbiscan.io/address/0xA1c93D2687f7014Aaf588c764E3Ce80aF016229b
export const ALC_SAFE = '0xA1c93D2687f7014Aaf588c764E3Ce80aF016229b';

// https://arbiscan.io/address/0xdef1FA4CEfe67365ba046a7C630D6B885298E210
export const MASIV_SAFE = '0xdef1FA4CEfe67365ba046a7C630D6B885298E210';

// https://arbiscan.io/address/0xdeadD8aB03075b7FBA81864202a2f59EE25B312b
export const MERIT_AHAB_SAFE = '0xdeadD8aB03075b7FBA81864202a2f59EE25B312b';

// https://arbiscan.io/address/0xAA43203167317DeeF8288095C44b84a686918d2E
export const APE_SAFE = '0xAA43203167317DeeF8288095C44b84a686918d2E';

// https://arbiscan.io/address/0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6
export const APE_VOTING_SAFE = '0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6';

// https://arbiscan.io/address/0xAAB6f926DCDaE536F54ce58478Dbc1a0d0f98871
export const ALC_INCENTIVE_SAFE = '0xAAB6f926DCDaE536F54ce58478Dbc1a0d0f98871';

// https://arbiscan.io/address/0xAA870e4B82deaDa3727235f34183Ec9B728714C8
export const MERIT_INCENTIVE_SAFE = '0xAA870e4B82deaDa3727235f34183Ec9B728714C8';

// https://arbiscan.io/address/0xAA2461f0f0A3dE5fEAF3273eAe16DEF861cf594e
export const AHAB_SAFE = '0xAA2461f0f0A3dE5fEAF3273eAe16DEF861cf594e';

// https://arbiscan.io/address/0x659966aCE41944f6E321cA7FE76de4775779d11C
export const REWARD_STEWARD = '0x659966aCE41944f6E321cA7FE76de4775779d11C';

// https://arbiscan.io/address/0xf4F2bc657abe96863dC1Ae17C9e9fFfc2B420e7B
export const AGENT_HUB = '0xf4F2bc657abe96863dC1Ae17C9e9fFfc2B420e7B';

// https://arbiscan.io/address/0xFf822f7E2178176bB650df82427a42cA0c04CcaB
export const AGENT_HUB_AUTOMATION = '0xFf822f7E2178176bB650df82427a42cA0c04CcaB';

// https://arbiscan.io/address/0x9240a6669CC4782FC98620212862DF5CB2e0Df10
export const RANGE_VALIDATION_MODULE = '0x9240a6669CC4782FC98620212862DF5CB2e0Df10';

export const CHAIN_ID = 42161;
